import { footerData } from "./footerData";
import { socials } from "./footerData";
import { Link } from "react-router-dom";
import Button from "components/dashboard/forms/button/Button";
import ercLogo from "../../assets/images/brandImg/erc-logo.png";

export const Footer = () => {
  return (
    <footer className=" mt-12 text-white bg-secondary">
      <div className="grid lg:grid-cols-3 md:grid-cols-3 grid-cols-1 gap-6 md:px-[64px] md:py-[80px] px-6 py-12 ">
        <div className="flex flex-col gap-6 w-full text-[12px] md:text-[16px]">
          <Link to="/" className="">
            <img
              src={ercLogo}
              alt="erc-logo"
            />
          </Link>

          <div className="flex gap-6 flex-col ">
            <p className="text-[16px]">
              The Lagos State Ministry of Basic and Secondary Education is the
              government ministry charged with the responsibility to plan,
              devise and implement the state policies on Education.
            </p>
            <div>
       <ul className="flex md:gap-4 gap-4 items-center">
  {socials.map((item) => (
    <li key={item.id}>
      <a href={item.link} aria-label={item.alt}>
        <item.icon className="w-5 h-5 " />
      </a>
    </li>
  ))}
</ul>
            </div>
          </div>
        </div>
        <div className="">
          <div className="grid  md:grid-cols-2 grid-cols-1 gap-6 w-full  ">
            {footerData.map((data, id) => (
              <div className="flex flex-col gap-8" key={id}>
                <h1 className="font-ManropeBold text-[24px] leading-6 ">
                  {data.label}
                </h1>
                <ul className="flex gap-4 flex-col font-ManropeLight text-[16px]">
                  {data.children &&
                    data.children.map((child, id) => (
                      <li className="" key={id}>
                        <a
                          href={child.link}
                          className="no-underline hover:underline"
                        >
                          {child.label}
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        {/* newsletter */}
        <div className="flex flex-col gap-8">
          <h1 className="font-semibold text-[24px] ">
            Stay Connected
          </h1>
          <div className="flex w-full bg-white">
            <input
              type="email"
              className="w-full  bg-white border-none outline-none px-6 bg-transparent text-neutral py-5 "
              placeholder="Enter Email Address"
            />
            <div className="w-fit">
              <Button className="bg-primary font-ManropeBold text-secondary px-12 py-5">Submit</Button>
            </div>
          </div>
          <p className="md:text-[16px] text-[#CCCCCC] leading-[32px]">
            Get the latest news and updates on new courses, ebemts and
            activities right in your mailbox.
          </p>
        </div>
      </div>
      <div className="flex md:flex-row flex-col  items-center md:justify-between pt-6 border-t-[1px] border-t-gray-300 md:px-[64px]  px-6 py-12">
        <div className="flex md:flex-row flex-col gap-6 items-center md:text-[16px]">
          <p>
            Copyright ⓒ LAGOS STATE MINISTRY OF BASIC AND SECONDARY EDUCATION,
            2024. All rights reserved.
          </p>
        </div>
        <ul className="flex gap-4 font-ManropeLight md:text-[16px]  text-[10px]">
          <li className="underline text-white">
            <a
              href="#"
              className="no-underline hover:underline  md:text-[16px]  text-[10px]"
            >
              Website Terms
            </a>
          </li>
          <li className="underline text-white">
            <a
              href="#"
              className="no-underline hover:underline  md:text-[16px]  text-[10px]"
            >
              Privacy Policy
            </a>
          </li>
          <li className="underline text-white">
            <a
              href="#"
              className="no-underline hover:underline  md:text-[16px]  text-[10px]"
            >
              Cookies Policy
            </a>
          </li>
        </ul>
      </div>
    </footer>
  );
};
